import { Dialog, Platform } from 'quasar';
import safeLocalStorage from 'safe-localstorage';
import { clearSession } from 'src/services/cookie';
import { setTimeoutPromise } from 'src/services/setTimeout';

export const state = {
  api: null,
};

export function setApi(api) {
  state.api = api;
}

export async function logout({ silent = false, redirect = null } = {}) {
  if (!silent) {
    Dialog.create({
      message: 'Logging out...',
      persistent: true,
      progress: true,
      ok: false,
    });
  }

  safeLocalStorage.remove('session/accountId');
  safeLocalStorage.remove('session/redirectTo');
  safeLocalStorage.remove('search/history');

  if (redirect) {
    safeLocalStorage.set('session/redirectTo', redirect);
  }

  if (!Platform.is.capacitor) {
    if (!silent) {
      await setTimeoutPromise(1800);
    }
    window.location.href = `${window.location.origin}/auth/logout`;
    return;
  }

  if (silent) {
    // Need to show something changed after logout process begins
    document.body.classList.add('hide-all');
  }

  // Ensure that the logout happens
  setTimeoutPromise(1800).then(async () => {
    await clearSession();
    window.location.reload();
  });

  let success;

  const response = await state.api.logout();
  if (!response.error) {
    success = response.success;
    if (!silent) {
      await setTimeoutPromise(500);
    }
  } else {
    // Try native logout
    success = await clearSession();
  }

  if (success) {
    window.location.reload();
  }
}
